export interface BrowserInfo {
  userAgent: string;
  platform: string;
  language: string;
  screenResolution: string;
  viewportSize: string;
}

export function collectBrowserInfo(): BrowserInfo {
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    screenResolution: `${screen.width}x${screen.height}`,
    viewportSize: `${window.innerWidth}x${window.innerHeight}`,
  };
}

export function getCurrentUrl(): string {
  return window.location.href;
}

declare const __APP_VERSION__: string;

export function getAppVersion(): string {
  try {
    return __APP_VERSION__;
  } catch {
    return 'unknown';
  }
}
